module.exports = __webpack_public_path__ + "png/quick-registration-puzzle-2.png?45324188aa87aecd1d7c17429bc81414";